import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Cancel = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/');
    }, 3000);
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="max-w-2xl mx-auto p-4">
      <div className="bg-red-50 rounded-lg p-6 text-center">
        <h2 className="text-2xl font-bold text-red-800 mb-4">
          Payment Cancelled
        </h2>
        <p className="text-red-600">
          Your subscription setup was cancelled.
          You will be redirected back to try again in a few seconds.
        </p>
      </div>
    </div>
  );
};

export default Cancel;